import { NgModule } from '@angular/core';
import { ErrorHandler } from '@angular/core';
import { APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { IConfig } from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { PortalModule } from './route/common/portal.module';
import { AppComponent } from './app.component';
import { StaffComponent } from './route/admin/staff/staff.component';
import { LoginComponent } from './route/authentication/login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { PartnerComponent } from './route/admin/partner/partner.component';
import { TemplateComponent } from './route/admin/template/template.component';
import { SettingsComponent } from './route/admin/settings/settings.component';
import { TrackCapsDirective } from './directive/caps.directive';
import { RequestInterceptor } from './interceptor/request.interceptor';
import { StaffEditComponent } from './route/admin/staff/edit/staff-edit/staff-edit.component';
import { OverwritesComponent } from './route/admin/overwrites/overwrites.component';
import { ResponseInterceptor } from './interceptor/response.interceptor';
import { PartnerEditComponent } from './route/admin/partner/edit/partner-edit/partner-edit.component';
import { TemplateEditComponent } from './route/admin/template/edit/template-edit/template-edit.component';
import { ResetPasswordComponent } from './route/authentication/reset-password/reset-password.component';
import { OverwriteEditComponent } from './route/admin/overwrites/edit/overwrite-edit/overwrite-edit.component';
import { OverwriteEventsComponent } from './route/admin/overwrites/events/overwrite-events.component';
import { VersionComponent } from './route/admin/version/version.component';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [
    TrackCapsDirective,
    AppComponent,
    LoginComponent,
    VersionComponent,
    StaffComponent,
    StaffEditComponent,
    PartnerComponent,
    SettingsComponent,
    PartnerEditComponent,
    TemplateComponent,
    TemplateEditComponent,
    ResetPasswordComponent,
    OverwritesComponent,
    OverwriteEditComponent,
    OverwriteEventsComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AngularEditorModule,
    InfiniteScrollModule,

    MatCardModule,
    MatMenuModule,
    MatSortModule,
    MatIconModule,
    MatTableModule,
    MatInputModule,
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatDividerModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBadgeModule,

    NgxMaskModule.forRoot(),
    PortalModule,
    SweetAlert2Module.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true},
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
